"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridContainer_1 = require("./GridContainer");
exports.default = GridContainer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridContainer/index.js
// module id = 549
// module chunks = 8